import React from "react";
import { Box, Typography, Skeleton } from "@mui/material";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { format } from 'date-fns';
import EmptyIcon from "../../../assets/images/empty-box.png";


const AuthenticationFailRateComponent = (props) => {
    const { authenticationFailRateData, isFetchingAuthenticationFailRate, breakpoints } = props;

    const combinedData = [
        ...(authenticationFailRateData?.product || []).map(item => ({
            date: format(new Date(item.date), 'MMMM dd, yyyy'),
            count: item.count
        })),
        ...(authenticationFailRateData?.document || []).map(item => ({
            date: format(new Date(item.date), 'MMMM dd, yyyy'),
            count: item.count
        }))
    ];

    const hasData = combinedData?.length > 0;
    const labels = hasData ? Object.keys(combinedData[0]).filter(key => key !== 'date') : [];

    console.log("authenticationFailRateData here",authenticationFailRateData)

    return (
        <Box width="100%" height={300} display="flex" alignItems="center" justifyContent="center">
            {isFetchingAuthenticationFailRate ? (
                <Skeleton variant="rectangular" width="100%" height={300} sx={{backgroundColor: "rgb(108 139 222 / 30%)"}} />
            ) : (
                <>
                    {hasData ? (
                        <ResponsiveContainer width="100%" height={300}>
                            <LineChart
                                width={500}
                                height={300}
                                data={combinedData}
                                margin={{
                                    top: 5,
                                    right: 30,
                                    left: 20,
                                    bottom: 5,
                                }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="date" />
                                <YAxis />
                                <Tooltip />
                                {labels.map((label, index) => (
                                    <Line type="monotone" key={label} dataKey={label} stroke="#82ca9d" />
                                ))}
                            </LineChart>
                        </ResponsiveContainer>
                    ) : (
                        <Box sx={{textAlign: "center", p: 1, pt: (breakpoints == "xs" || breakpoints == "sm") ? {} : "24px"}}>
                            <img alt="empty-data-icon" src={EmptyIcon} width="140" />

                            <Typography sx={{color: "#58565f", fontSize: 14, mt: 1}}>
                                No data available for the selected date range
                            </Typography>
                        </Box>    
                    )}
                </>
            )}
        </Box>
    );
};

export default AuthenticationFailRateComponent;
